import { z } from 'zod';
import type { Database } from '@/shared/types';

export const CarModelSchema = z.object({
	id: z.string(),
	brand_logo: z.string().nullable(),
	brand: z.string(),
	brand_en: z.string().nullable(),
	model: z.string(),
	max_fuel_efficiency: z.string().nullable(),
	min_fuel_efficiency: z.string().nullable(),
	average_fuel_efficiency: z.string().nullable(),
}) satisfies z.ZodType<Database['public']['Tables']['car_information']['Row']>;

export type CarModel = z.infer<typeof CarModelSchema>;
